import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { message } from 'antd';
import { Builder } from '@adsign/ui-builder';
import { url, imgUrl } from 'utils/url';
import '@adsign/ui-builder/styles.css';
import { builderFontsApiKey, createBuilderServices, resolveBuilderMediaUrl, resolveFontUrl } from './services';

const getBuilderPermissions = (userData = {}) => ({
  canCreate: true,
  canEdit: true,
  canDelete: ['admin', 'superadmin'].includes(userData.role),
});

function BuilderPage() {
  const { siteId, siteName } = useParams();
  const userData = useSelector((state) => state.auth?.userData || {});

  const services = useMemo(() => createBuilderServices(), []);
  const permissions = useMemo(() => getBuilderPermissions(userData), [userData]);

  const handleError = useCallback((error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      message.error('Your session is no longer val  id. Please sign in again.');
    }
    console.log(url, error, imgUrl);
  }, []);

  return (
    <Builder
      site={{ id: siteId, name: siteName }}
      services={services}
      apiUrl={url}
      imageUrl={imgUrl}
      fontsApiKey={builderFontsApiKey}
      resolveMediaUrl={resolveBuilderMediaUrl}
      resolveFontUrl={resolveFontUrl}
      permissions={permissions}
      onError={handleError}
    />
  );
}

export default BuilderPage;
